export const extraShortInputStyle = { width: 80 };
export const shortInputStyle = { width: 100 };
export const mediumInputStyle = { width: 180 };
export const dateTimeInputStyle = { width: 200 };
